<template>
  <div>
    <div class="futures_box">
      <div class="table_show" ref="table_show">
        <table-show @select="onSelect" :data="FutureList" :height="tableHeight">
          <el-table-column prop="name" :label="$transform('SYMBOL')">
            <template slot-scope="{ row }">
              <span class="table_cell_1">{{ $transform(row.name) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="LAST" :label="$transform('PRICE')">
            <template slot-scope="{ row }">
              <span class="table_cell_2">{{ row.LAST }}</span>
            </template>
          </el-table-column>
          <el-table-column sortable prop="CHG" :label="$transform('CHANGE')">
            <template slot-scope="scope">
              <span
                style="color: #171717; font-weight: 300"
                v-if="scope.row.CHG == 'UNCH'"
                >{{ scope.row.CHG }}</span
              >
              <span
                style="color: #ce2b2b; font-weight: 300"
                v-else-if="scope.row.isreduce && scope.row.CHG"
                >{{ scope.row.CHG }}</span
              >
              <span
                v-else-if="!scope.row.isreduce && scope.row.CHG"
                style="color: #008456; font-weight: 300"
              >
                <span>+{{ scope.row.CHG }}</span>
              </span>
              <span
                v-if="!scope.row['CHG']"
                style="color: #008456; font-weight: 300"
                >-</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="%CHG" :label="$transform('%CHANGE')">
            <template slot-scope="scope">
              <span
                class="flex_end un_icon"
                style="color: #171717; font-weight: 300"
                v-if="scope.row['%CHG'] == 'UNCH'"
                >{{ scope.row["%CHG"] }}</span
              >
              <span
                class="flex_end reduce_icon"
                style="color: #ce2b2b; font-weight: 300"
                v-else-if="scope.row.isreduce && scope.row['%CHG']"
                >{{ scope.row["%CHG"] }}</span
              >
              <span
                class="flex_end add_icon"
                v-else-if="!scope.row.isreduce && scope.row['%CHG']"
              >
                <span
                  v-if="scope.row['%CHG']"
                  style="color: #008456; font-weight: 300"
                  >+{{ scope.row["%CHG"] }}</span
                >
              </span>
              <span
                class="flex_end un_icon"
                v-if="!scope.row['%CHG']"
                style="color: #008456; font-weight: 300"
                >-</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="Volume" :label="$transform('VOLUME')">
            </el-table-column> -->
        </table-show>
      </div>
      <bottom-tip></bottom-tip>
    </div>
  </div>
</template>

<script>
import mixin from "@/libs/mixin";
export default {
  mixins: [mixin],
  data() {
    return {
      FutureList: [],
      tabList: [],
      activeName: "",
      tableHeight: null,
    };
  },
  mounted() {
    this.loading = this.$loading();
    let tabType = this.$route.query.tabType;
    this.getFutureList(tabType);
    this.changeView(this.$refs.table_show, () => {
      let h = this.$refs.table_show.offsetHeight;
      this.tableHeight = h;
    });
  },
  methods: {
    onSelect(item) {
      let tabType = this.$route.query.tabType;
      window.parent.postMessage(
        JSON.stringify({
          type: "futuresDetail",
          tabType: encodeURIComponent(tabType),
          rowName: encodeURIComponent(item.name),
          path: "/product/futures-detail",
          url: `${
            window.location.origin
          }/product/futures-detail?tabType=${encodeURIComponent(
            tabType
          )}&rowName=${encodeURIComponent(item.name)}`,
        }),
        "*"
      );
    },

    getFutureList(type) {
      return this.$tool
        .fetchPost("/api/getCharts3TabData", { type })
        .then((res) => {
          let { code, data } = res;
          this.loading.close();
          if (code == 200) {
            data.forEach((item) => {
              item.isreduce = parseFloat(item["%CHG"]) < 0;
              item.LAST = item.LAST || "-";
              item.Volume = item.Volume || "-";
            });
            this.FutureList = data;
          }
        })
        .catch(() => {
          this.loading.close();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.futures_box {
  width: 100%;
  height: 100vh;
  .top_title {
    margin-bottom: 30px;
    .title {
      font-size: 32px;

      font-weight: 300;
      color: #333333;
    }
    .time {
      font-size: 12px;
      font-weight: 300;
      color: #333333;
    }
  }

  .table_show {
    margin-bottom: 10px;
    width: 100%;
    // height: calc(100vh - 75px - 17px - 10px);
    height: calc(100vh - 15px - 10px);
    .reduce_icon {
      width: 70px;
      &::after {
        content: "";
        width: 14px;
        height: 14px;
        background: url("../assets/images/down_reduce.png") no-repeat center
          center;
        background-size: 100% 100%;
        margin-left: 4px;
      }
    }
    .un_icon {
      width: 70px;
      &::after {
        content: "";
        width: 14px;
        height: 14px;
        background-size: 100% 100%;
        margin-left: 4px;
      }
    }
    .add_icon {
      width: 70px;
      &::after {
        content: "";
        width: 14px;
        height: 14px;
        background: url("../assets/images/up_add.png") no-repeat center center;
        background-size: 100% 100%;
        margin-left: 4px;
      }
    }
    ::v-deep .el-table .cell {
      cursor: pointer !important;
    }
  }
}
</style>
